/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface LeadWaitlistUpdatesInner
 */
export interface LeadWaitlistUpdatesInner {
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistUpdatesInner
     */
    waitlist_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistUpdatesInner
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistUpdatesInner
     */
    created_by_user_id?: string;
    /**
     * 
     * @type {User}
     * @memberof LeadWaitlistUpdatesInner
     */
    created_by_user?: User;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistUpdatesInner
     */
    created_at?: string;
}

/**
 * Check if a given object implements the LeadWaitlistUpdatesInner interface.
 */
export function instanceOfLeadWaitlistUpdatesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadWaitlistUpdatesInnerFromJSON(json: any): LeadWaitlistUpdatesInner {
    return LeadWaitlistUpdatesInnerFromJSONTyped(json, false);
}

export function LeadWaitlistUpdatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlistUpdatesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'waitlist_id': !exists(json, 'waitlist_id') ? undefined : json['waitlist_id'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'created_by_user_id': !exists(json, 'created_by_user_id') ? undefined : json['created_by_user_id'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : UserFromJSON(json['created_by_user']),
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function LeadWaitlistUpdatesInnerToJSON(value?: LeadWaitlistUpdatesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'waitlist_id': value.waitlist_id,
        'comment': value.comment,
        'created_by_user_id': value.created_by_user_id,
        'created_by_user': UserToJSON(value.created_by_user),
        'created_at': value.created_at,
    };
}

